import { MetaArguments, SweepArguments } from "../../views/GeneralTask/generalTask.types";
import { pluralCompare } from "../../views/GeneralTask/generalTask.service";

export const filterMetaArguments = (metaArguments: ReadonlyMeta, sweepArguments: string[]): MetaArguments => {
  if (!metaArguments) {
    return [];
  }
  const filteredMeta: MetaArguments = [];
  metaArguments.map((kv) => {
    if (
      kv?.k &&
      kv?.v &&
      sweepArguments.some((argument) => argument.includes(kv.k as string) || pluralCompare(argument, kv.k as string))
    ) {
      filteredMeta.push({
        k: kv.k,
        v: kv.v,
      });
    }
  });
  return filteredMeta;
};

export const filteredMetaGT = (metaArguments: ReadonlyMeta, sweepArguments: SweepArguments): MetaArguments => {
  if (!metaArguments) {
    return [];
  }
  const metaList: MetaArguments = [];

  metaArguments.map((kv) => {
    if (
      kv?.k &&
      kv?.v &&
      sweepArguments?.some((argument) => {
        return argument?.k?.includes(kv.k as string) || pluralCompare(argument?.k as string, kv.k as string);
      })
    ) {
      metaList.push(kv);
    }
  });
  return metaList;
};

export type ReadonlyMeta =
  | readonly ({ readonly k: string | null | undefined; readonly v: string | null | undefined } | null | undefined)[]
  | null
  | undefined;
